import { render, staticRenderFns } from "./orderBind.vue?vue&type=template&id=6284a703&scoped=true&"
import script from "./orderBind.vue?vue&type=script&lang=js&"
export * from "./orderBind.vue?vue&type=script&lang=js&"
import style0 from "./orderBind.vue?vue&type=style&index=0&id=6284a703&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6284a703",
  null
  
)

export default component.exports